import { IPostingQuery } from '../interfaces/interfaces/posting.query.interface';
import { PostingCommand } from '../models/posting.command.model';
import { Posting } from '../models/posting.model';
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPostingType } from '../interfaces/interfaces/posting-type.query.interface';
import { PostingType } from '../models/posting-type.model';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';

@Injectable()
export class PostingTypeApiService extends EntityService<IPostingQuery, PostingCommand> implements IEntityApiService<Posting> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'engage/posting-types');
    }

    getAll(): Observable<Posting[]> {
        return this._getAll().pipe(map((queries) => queries.map((query) => new Posting(query))));
    }

    create(entity: Posting): Observable<Posting> {
        const postingData = new PostingCommand(entity);

        return this._create(postingData).pipe(map((postingQuery) => new Posting(postingQuery)));
    }

    delete(id: string): Observable<any> {
        return this._delete(id);
    }

    read(id: string): Observable<Posting> {
        return this.http.get<IPostingQuery>(`${this.apiUrl}/${this.entities}/${id}`).pipe(map((query) => new Posting(query)));
    }

    update(entity: Posting): Observable<Posting> {
        const data = new PostingCommand(entity);
        delete data.posting_type.id;

        return this._update(entity.id, data).pipe(map((query) => new Posting(query)));
    }

    getPostingTypes(type?: string): Promise<PostingType[]> {
        let params = new HttpParams();

        if (type) {
            params = params.set('filter[enabled]', type);
        }

        return this.http
            .get<IPostingType[]>(`${this.apiUrl}/engage/posting-types`, { params })
            .pipe(map((queries) => queries.map((query) => new PostingType(query))))
            .toPromise();
    }
}
